import { Button } from "@aidron/aidron-ds";
import { i18n } from "../../../../translate/i18n";

const { t } = i18n;

export const DefaultBtn = ({ actions, ctx, uiState }) => {

    const { setShowInputs, setShowCancelModal, onInputsSave } = actions || {};
    const { suppliersAndProductRelations } = ctx || {};
    const { customDisabledCondition, showInputs } = uiState || {};

    const editButtonDisabled = customDisabledCondition !== false 
        ? !customDisabledCondition 
        : !suppliersAndProductRelations?.length;
    
    return (
        <div style={{ display: 'flex', gap: '1rem' }}>
            {!showInputs ? (
            <Button onClick={() => setShowInputs(true)} label={t("edit")} disabled={editButtonDisabled} />
            ) : (
            <Button onClick={() => setShowCancelModal(true)} label={t("cancelEdit")} />
            )}
            <Button onClick={onInputsSave} label={t("save")} type="outlined" disabled={!showInputs} />    
        </div>
    )
}